<template>
  <div
    v-if="method"
  >
    <v-widget
      :title="method.name"
    >
      <div slot="widget-header-action">
        <v-switch
          slot="activator"
          v-model="method.enabled"
          :label="$t('Enabled')"
          class="mt-4"
        />
      </div>
      <div slot="widget-content">
        <v-form>
          <v-container>
            <v-layout
              v-if="method"
              row
              wrap
              color="transparent">
              <v-flex xs12>
                <translations-tabs>
                  <template #default="{language}">
                    <translatable
                      :language="language"
                      v-model="method"
                      field-name="name"
                    >
                      <template
                        #default="{ fieldValue, fieldMutator }"
                      >
                        <v-text-field
                          v-model="fieldValue"
                          :error-messages="method.displayErrors('name')"
                          :label="$t('Name')"
                          outline
                          @change="fieldMutator(fieldValue)"
                        />
                      </template>
                    </translatable>
                  </template>
                </translations-tabs>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-if="method.isNew"
                  v-model="method.code"
                  :error-messages="method.displayErrors('code')"
                  :label="$t('Code')"
                  outline
                />
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="method.type"
                  :items="shipping_types"
                  :error-messages="method.displayErrors('type')"
                  :label="$t('Type')"
                  item-text="name"
                  item-value="value"
                  outline
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="method.carrier"
                  :error-messages="method.displayErrors('carrier')"
                  :label="$t('Carrier')"
                  outline
                />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="method.order"
                  :error-messages="method.displayErrors('order')"
                  :label="$t('Order')"
                  type="number"
                  outline
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model="method.min_delivery_days"
                  :error-messages="method.displayErrors('min_delivery_days')"
                  :label="$t('Min delivery days')"
                  outline
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  v-model="method.max_delivery_days"
                  :error-messages="method.displayErrors('max_delivery_days')"
                  :label="$t('Max delivery days')"
                  outline
                />
              </v-flex>
              <shipping-price
                v-if="taxesSettings"
                :method="method"
                :taxes="taxes"
                :settings="taxesSettings"
              />
              <v-flex
                v-if="method.type !== 'pickup'"
                xs12>
                <template v-if="!zonesLoaded">
                  <div>{{ $t('Loading locations') }}</div>
                  <v-progress-linear :indeterminate="true" />
                </template>
                <v-combobox
                  v-else
                  v-model="selectedZones"
                  :items="zones"
                  :disabled="!zones.length"
                  :label="$t('Locations')"
                  item-text="label"
                  item-value="code"
                  outline
                  multiple
                  @change="setZones"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </v-widget>
  </div>
</template>

<script>
import ZoneService from '@/modules/Settings/service'
import { mapGetters } from 'vuex'
import MoneyInput from '@/components/form/MoneyInput'
import ShippingPrice from '@/modules/Settings/components/Shippings/ShippingPrice'
import Translatable from '@/components/widgets/Translatable'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'

export default {
  name: 'ShippingMethodForm',

  components: {
    TranslationsTabs,
    Translatable,
    ShippingPrice,
    MoneyInput
  },

  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      selectedPriceType: '',
      selectedZones: [],
      zones: [],
      zonesLoaded: false,
      taxes: [],
      taxesSettings: null
    }
  },

  computed: {
    ...mapGetters(['currency']),

    shipping_types () {
      return [
        {
          name: this.$t('Delivery'),
          value: 'delivery'
        },
        {
          name: this.$t('Pick Up'),
          value: 'pickup'
        }
      ]
    }
  },

  watch: {
    'method.type': function () {
      if (this.method.type === 'pickup') {
        this.selectedZones = []
        this.method.zone_codes = []
      }
    }
  },

  async mounted () {
    this.taxes = await this.$http.make('vat').limit(-1).get()
    this.taxesSettings = await this.$http.make('settings').find('general/taxes')
  },

  async created () {
    this.selectedZones = []
    this.zones = await ZoneService.loadZones()
    this.zonesLoaded = true
    this.selectedZones = this.method.zone_codes ? this.method.zone_codes.map(zone => this.zones.find(fetchedZone => {
      return fetchedZone.code === zone
    })) : []
  },

  methods: {
    setZones (value) {
      this.method.zone_codes = value.length ? value.map(zone => zone.code) : null
    }
  }
}
</script>
